/* @flow */
import { format as formatUrl } from 'url';
import {
  sendGAPageView,
  sendComscorePageview,
  sendChartbeatPageview,
  updateGACustomVariables,
  updateDataLayerMetadata,
  dataLayerSendPageview
} from './analytics';
import { sendParselyPageview } from '../vendor/beacons/parsely';
import updateDfpCorrelator from './ads/updateDfpCorrelator';
import { updateChartbeatConfig } from '../vendor/beacons/chartbeat';
import { sendNielsenPageview } from '../utils/nielsen';
import {each, get} from 'lodash';


type Beacon =
    'chartbeat'
  | 'comscore'
  | 'dfp'
  | 'google'
  | 'newsroom'
  | 'parsely'
  | 'nielsen'
;

type Params = {
  beacons: Beacon[],
  loc: Object,
  prevLoc?: Object,
  state: Object
};

export default ({
  beacons,
  loc,
  prevLoc,
  state
}: Params): ?false => {
  if (state.isPreviewPage) { return false; }
  each(beacons, (beacon: Beacon): void => {
    switch (beacon) {
      case 'comscore':
        sendComscorePageview(loc);
        break;
      case 'chartbeat':
        updateChartbeatConfig(state);
        sendChartbeatPageview(loc, state);
        break;
      case 'google':
        updateGACustomVariables(state);
        sendGAPageView(loc);
        updateDataLayerMetadata(loc, state);
        dataLayerSendPageview(loc, state);
        break;
      case 'dfp':
        updateDfpCorrelator();
        break;
      case 'parsely':
        sendParselyPageview(
          prevLoc ? formatUrl(prevLoc) : '',
          formatUrl(loc)
        );
        break;
      case 'nielsen':
        sendNielsenPageview(get(state, 'ads.ad_data'));
        break;
    }
  });
};
